import type { enKasir } from '../en/kasir';

export const idKasir: Record<keyof typeof enKasir, string> = {
  'kasir.nav.tables': 'Meja',
  'kasir.nav.shift': 'Shift kas',
  'kasir.floor.subtitle': 'Pilih meja untuk membuka, memesan, atau menagih.',

  // ---- Tagihan --------------------------------------------------------------------
  'kasir.bill.tab': 'Tagihan',
  'kasir.bill.lines': 'Rincian tagihan',
  'kasir.bill.item': 'Item',
  'kasir.bill.amount': 'Jumlah',
  'kasir.bill.subtotal': 'Subtotal',
  'kasir.bill.service': 'Biaya layanan ({percent}%)',
  'kasir.bill.tax': 'Pajak ({percent}%)',
  'kasir.bill.rounding': 'Pembulatan',
  'kasir.bill.total': 'Total',
  'kasir.bill.paid': 'Dibayar',
  'kasir.bill.outstanding': 'Sisa tagihan',
  'kasir.bill.number': 'Tagihan {number}',
  'kasir.bill.ready': 'Tagihan {number} siap.',
  'kasir.bill.nothing': 'Belum ada yang ditagih — item muncul di sini setelah dikirim ke dapur.',
  'kasir.bill.createHint': '{count} item terkirim akan ditagih. Total dihitung oleh server.',
  'kasir.bill.create': 'Buat tagihan',
  'kasir.bill.creating': 'Membuat tagihan…',
  'kasir.bill.draftsWarning': '{count} item belum dikirim dan tidak masuk tagihan.',
  'kasir.bill.refreshHint': '{count} item dikirim setelah tagihan ini dibuat.',
  'kasir.bill.refresh': 'Perbarui tagihan',
  'kasir.bill.refreshing': 'Memperbarui…',
  'kasir.bill.void': 'Batalkan tagihan',
  'kasir.bill.voidTitle': 'Batalkan tagihan {number}?',
  'kasir.bill.voidBody':
    'Hanya untuk tagihan yang belum dibayar. Item tetap ada di pesanan: batalkan atau tagih ulang.',
  'kasir.bill.voiding': 'Membatalkan…',
  'kasir.bill.voided': 'Tagihan {number} dibatalkan',
  'kasir.bill.payments': 'Pembayaran',
  'kasir.bill.paymentLine': 'Tunai · {time}',

  // ---- Pembayaran -----------------------------------------------------------------
  'kasir.pay.needShift': 'Buka shift kas sebelum menerima pembayaran.',
  'kasir.pay.tendered': 'Uang diterima',
  'kasir.pay.quick': 'Nominal cepat',
  'kasir.pay.exact': 'Uang pas',
  'kasir.pay.changeEstimate': 'Perkiraan kembalian:',
  'kasir.pay.partialEstimate': 'Bayar sebagian — sisa:',
  'kasir.pay.exactEstimate': 'Uang pas — tanpa kembalian.',
  'kasir.pay.enterAmount': 'Masukkan uang yang diterima.',
  'kasir.pay.action': 'Terima tunai {amount}',
  'kasir.pay.pending': 'Mencatat pembayaran…',
  'kasir.pay.partialDone': 'Diterima {paid}. Sisa {remaining}.',
  'kasir.keypad.label': 'Papan angka',
  'kasir.keypad.backspace': 'Hapus angka terakhir',

  // ---- Struk ----------------------------------------------------------------------
  'kasir.receipt.title': 'Struk',
  'kasir.receipt.browserPrint':
    'Lunas. Cetak memakai dialog cetak browser — bukan printer struk thermal.',
  'kasir.receipt.print': 'Cetak (browser)',
  'kasir.receipt.done': 'Selesai',
  'kasir.receipt.change': 'Kembalian',
  'kasir.receipt.tenderedLine': 'Uang diterima',
  'kasir.receipt.billNo': 'Tagihan {number}',
  'kasir.shift.cashRefunds': 'Refund tunai',
  'kasir.shift.stale':
    'Shift ini terbuka sejak {date}. Hitung uang di laci dan tutup shift, lalu buka shift baru untuk hari ini.',
  'kasir.shift.cashRefundsDescription': 'Uang tunai yang dikembalikan dari laci ini.',
  'kasir.refund.online': 'Online',
  'kasir.refund.onlineAction': 'Kembalikan bayar online {amount}',
  'kasir.refund.onlineTitle': 'Kembalikan pembayaran online tagihan {number}',
  'kasir.refund.onlineBody':
    'Tamu membayar {amount} secara online, tetapi tagihan tidak bisa menerimanya. Penyedia pembayaran mengembalikan seluruhnya.',
  'kasir.refund.onlineDone': 'Pembayaran online tagihan {number} dikembalikan',
  'kasir.refund.mode': 'Refund per',
  'kasir.refund.pendingNote': 'menunggu penyedia',
  'kasir.refund.byItems': 'Item',
  'kasir.refund.byAmount': 'Jumlah',
  'kasir.refund.unitsLeft': 'Sisa {count} bisa di-refund',
  'kasir.refund.less': 'Kurangi satu {name}',
  'kasir.refund.more': 'Tambah satu {name}',
  'kasir.refund.total': 'Refund:',
  'kasir.refund.onlineNote':
    'Penyedia pembayaran yang mengembalikan uangnya; konfirmasinya bisa butuh waktu.',
  'kasir.refund.slipTitle': 'Slip refund',
  'kasir.refund.slipTotal': 'Dikembalikan',
  'kasir.refund.slipReason': 'Alasan: {reason}',
  'kasir.refund.slipPending': 'Menunggu konfirmasi penyedia pembayaran.',
  'kasir.refund.title': 'Refund',
  'kasir.refund.description':
    'Tagihan lunas hari ini. Refund mengembalikan uang; tagihan tetap lunas.',
  'kasir.refund.empty': 'Belum ada tagihan lunas hari ini.',
  'kasir.refund.action': 'Refund',
  'kasir.refund.refunded': '{amount} dikembalikan',
  'kasir.refund.dialogTitle': 'Refund tagihan {number}',
  'kasir.refund.payment': 'Pembayaran',
  'kasir.refund.amount': 'Jumlah dikembalikan',
  'kasir.refund.max': 'Paling banyak {amount}',
  'kasir.refund.cashNote':
    'Uang tunai keluar dari laci Anda dan mengurangi kas seharusnya di shift Anda.',
  'kasir.refund.confirm': 'Kembalikan uang',
  'kasir.refund.pending': 'Memproses refund…',
  'kasir.refund.done': '{amount} dikembalikan',
  'kasir.receipt.pickupNo': 'No. ambil {number}',
  'kasir.receipt.cashTendered': 'Tunai',
  'kasir.receipt.changeLine': 'Kembalian',
  'kasir.receipt.thanks': 'Terima kasih!',
  'kasir.receipt.notSettled': 'Belum lunas.',

  // ---- Shift ----------------------------------------------------------------------
  'kasir.shift.title': 'Shift kas',
  'kasir.shift.subtitle': 'Pembayaran tunai dicatat di shift Anda yang sedang buka.',
  'kasir.shift.statusOpen': 'Shift buka',
  'kasir.shift.statusNone': 'Shift belum dibuka',
  'kasir.shift.noneBanner':
    'Belum ada shift kas yang buka. Buka shift sebelum menerima pembayaran tunai.',
  'kasir.shift.openAction': 'Buka shift kas',
  'kasir.shift.openTitle': 'Buka shift kas',
  'kasir.shift.openDescription': 'Hitung uang di laci lalu masukkan sebagai modal awal.',
  'kasir.shift.float': 'Modal awal',
  'kasir.shift.floatDescription': 'Uang di laci saat dibuka',
  'kasir.shift.open': 'Buka shift',
  'kasir.shift.opening': 'Membuka…',
  'kasir.shift.opened': 'Shift kas dibuka.',
  'kasir.shift.openedBy': 'Dibuka oleh {name} · {time}',
  'kasir.shift.expected': 'Kas seharusnya',
  'kasir.shift.expectedDescription': 'Modal awal + penjualan tunai + kas masuk − kas keluar',
  'kasir.shift.cashSales': 'Penjualan tunai',
  'kasir.shift.cashSalesDescription':
    '{count} pembayaran tunai di shift ini (pembayaran platform delivery bukan tunai)',
  'kasir.shift.payIn': 'Kas masuk',
  'kasir.shift.payInDescription': 'Uang yang ditambahkan ke laci',
  'kasir.shift.payOut': 'Kas keluar',
  'kasir.shift.payOutDescription': 'Uang yang diambil dari laci',
  'kasir.move.title': 'Kas masuk / keluar',
  'kasir.move.description':
    'Catat uang yang ditambahkan ke atau diambil dari laci, beserta alasannya.',
  'kasir.move.type': 'Jenis pergerakan',
  'kasir.move.payIn': 'Kas masuk',
  'kasir.move.payOut': 'Kas keluar',
  'kasir.move.amount': 'Jumlah',
  'kasir.move.reason': 'Alasan',
  'kasir.move.reasonPlaceholder': 'mis. uang kembalian dari bank, beli es batu',
  'kasir.move.submit': 'Catat pergerakan',
  'kasir.move.doneIn': 'Kas masuk {amount} dicatat.',
  'kasir.move.doneOut': 'Kas keluar {amount} dicatat.',
  'kasir.close.title': 'Tutup shift',
  'kasir.close.description': 'Hitung uang di laci. Selisihnya akan dicatat.',
  'kasir.close.counted': 'Uang terhitung',
  'kasir.close.diffEstimate': 'Selisih (perkiraan):',
  'kasir.close.notes': 'Catatan',
  'kasir.close.submit': 'Tutup shift',
  'kasir.close.closing': 'Menutup…',
  'kasir.close.confirmTitle': 'Tutup shift kas ini?',
  'kasir.close.confirmBody':
    'Terhitung {counted} dibanding seharusnya {expected}. Shift yang ditutup tidak dapat dibuka lagi.',
  'kasir.close.done': 'Shift kas ditutup.',
  'kasir.close.balanced': 'pas',
  'kasir.close.short': 'kurang',
  'kasir.close.over': 'lebih',
  'kasir.close.resultTitle': 'Shift ditutup',
  'kasir.close.resultDescription': 'Angka sudah dikonfirmasi server.',
  'kasir.close.discrepancy': 'Selisih',

  // ---- Pesanan bawa pulang & delivery (/kasir/pesanan) -------------------------
  'kasir.shiftReport.title': 'LAPORAN SHIFT',
  'kasir.shiftReport.cashier': 'Kasir: {name}',
  'kasir.shiftReport.opened': 'Buka: {time}',
  'kasir.shiftReport.closed': 'Tutup: {time}',
  'kasir.shiftReport.cash': 'Laci kas',
  'kasir.shiftReport.items': 'Menu terjual',
  'kasir.shiftReport.tables': 'Per meja',
  'kasir.shiftReport.table': 'Meja {name}',
  'kasir.shiftReport.transactions': 'Transaksi',
  'kasir.shiftReport.printed': 'Dicetak {time}',
  'kasir.shiftReport.print': 'Cetak laporan',
  'kasir.shiftReport.printing': 'Mencetak…',
  'kasir.nav.report': 'Laporan',
  'kasir.report.title': 'Laporan shift',
  'kasir.report.subtitle':
    'Shift kas Anda saat ini: total, kas masuk/keluar, refund dan tutup shift.',
  'kasir.report.tab.summary': 'Ringkasan',
  'kasir.report.tab.cash': 'Kas',
  'kasir.report.tab.refunds': 'Refund',
  'kasir.report.tab.close': 'Tutup shift',
  'kasir.report.byMethod': 'Total per metode pembayaran',
  'kasir.nav.transactions': 'Transaksi',
  'kasir.tx.title': 'Transaksi',
  'kasir.tx.subtitle': 'Pembayaran dan refund di shift Anda saat ini.',
  'kasir.tx.tabShift': 'Shift ini ({count})',
  'kasir.tx.tabOpen': 'Pesanan terbuka ({count})',
  'kasir.tx.noShift': 'Buka shift kas untuk mulai mencatat transaksi.',
  'kasir.tx.empty': 'Belum ada transaksi di shift ini.',
  'kasir.tx.net': 'Total shift ini',
  'kasir.tx.netHint': 'Pembayaran diterima dikurangi refund, semua metode',
  'kasir.tx.count': '{count} pembayaran',
  'kasir.tx.refund': 'Refund',
  'kasir.tx.platform': 'Platform',
  'kasir.nav.orders': 'Pesanan',
  'kasir.nav.menu': 'Menu',
  'kasir.orders.title': 'Bawa pulang & delivery',
  'kasir.orders.subtitle': 'Pesanan tanpa meja: bawa pulang di kasir dan platform delivery.',
  'kasir.orders.new': 'Pesanan baru',
  'kasir.orders.openTitle': 'Pesanan terbuka',
  'kasir.orders.openDescription':
    'Status dapur per pesanan; buka pesanan untuk menambah item, membuat tagihan, dan menerima pembayaran.',
  'kasir.orders.empty': 'Belum ada pesanan bawa pulang atau delivery — buat lewat "Pesanan baru".',
  'kasir.orders.closedTitle': 'Selesai hari ini ({count})',
  'kasir.orders.closedHint': 'Pesanan bawa pulang dan delivery yang lunas hari ini.',
  'kasir.orders.closedEmpty': 'Belum ada pesanan bawa pulang atau delivery yang selesai hari ini.',
  'kasir.orders.col.number': 'Pesanan',
  'kasir.orders.col.type': 'Jenis',
  'kasir.orders.col.ref': 'No. platform',
  'kasir.orders.col.customer': 'Pelanggan',
  'kasir.orders.col.items': 'Item',
  'kasir.orders.col.kitchen': 'Dapur',
  'kasir.orders.col.total': 'Dipesan',
  'kasir.orders.back': 'Kembali ke pesanan',
  'kasir.orders.number': 'Pesanan {number}',
  'kasir.orders.closedNote': 'Pesanan ini sudah lunas dan selesai.',
  'kasir.orders.cancelledNote': 'Pesanan ini dibatalkan.',
  'kasir.pickup.title': 'Siap diambil',
  'kasir.pickup.description': 'Dapur sudah menandai siap. Serahkan ke pelanggan atau kurir.',
  'kasir.pickup.action': 'Serahkan',
  'kasir.pickup.done': 'Diserahkan: {label}.',
  'kasir.newOrder.title': 'Pesanan baru',
  'kasir.newOrder.description': 'Bawa pulang di kasir, atau pesanan dari platform delivery.',
  'kasir.newOrder.type': 'Jenis pesanan',
  'kasir.newOrder.platform': 'Platform delivery',
  'kasir.newOrder.ref': 'Nomor pesanan platform',
  'kasir.newOrder.refHint': 'Seperti di aplikasi platform, mis. GF-123456.',
  'kasir.newOrder.customer': 'Nama pelanggan',
  'kasir.newOrder.submit': 'Buat pesanan',
  'kasir.newOrder.created': 'Pesanan {number} dibuat.',
  'kasir.newOrder.error.channel': 'Pilih platform delivery.',
  'kasir.newOrder.error.refRequired': 'Masukkan nomor pesanan platform.',
  'kasir.newOrder.error.refTooLong': 'Maksimal 40 karakter.',
  'kasir.newOrder.error.refDuplicate': 'Pesanan platform ini sudah pernah dimasukkan.',
  'kasir.newOrder.error.nameTooLong': 'Maksimal 80 karakter.',

  // ---- Pembayaran platform (delivery) ------------------------------------------
  'kasir.bill.platformLine': 'Platform · {time}',
  'kasir.platform.hint':
    'Dibayar pelanggan ke {platform}. Tanpa uang tunai dan tidak perlu shift kas.',
  'kasir.platform.action': 'Tandai dibayar via {platform}',
  'kasir.platform.confirmTitle': 'Tandai tagihan ini dibayar via {platform}?',
  'kasir.platform.confirmBody':
    '{amount} dicatat sebagai dibayar oleh {platform} untuk pesanan platform {ref}. Tidak dihitung sebagai tunai.',
  'kasir.receipt.platformPaid': 'Dibayar via {platform}',
  'kasir.receipt.platformLine': 'Dibayar via {platform}',

  // ---- Menu & ketersediaan (/kasir/menu) ---------------------------------------
  'kasir.menu.title': 'Menu',
  'kasir.menu.subtitle': 'Tandai menu habis saat dapur kehabisan, lalu tersedia lagi nanti.',
  'kasir.menu.subtitleReadOnly': 'Menu cabang ini beserta harga dan ketersediaannya.',
  'kasir.menu.availableOnly': 'Hanya yang tersedia',
  'kasir.menu.options': 'Pilihan: {groups}',
  'kasir.menu.available': 'Tersedia',
  'kasir.menu.markSoldOut': 'Tandai habis',
  'kasir.menu.markAvailable': 'Tandai tersedia',
  'kasir.menu.markedSoldOut': '{name} ditandai habis.',
  'kasir.menu.markedAvailable': '{name} tersedia lagi.',
  // ---- Pembayaran online tamu --------------------------------------------------------------
  'kasir.bill.onlineLine': 'Online · {time}',
  'kasir.bill.onlinePending': 'Tamu sedang membayar {amount} di aplikasi. Jangan tagih dua kali.',
  'kasir.bill.onlineRefund':
    'Pembayaran online {amount} harus dikembalikan ke tamu: tagihan tidak dapat menerimanya.',
  'kasir.receipt.onlinePaid': 'Dibayar online',
  'kasir.receipt.onlineLine': 'Dibayar online',
  'kasir.orders.searchPlaceholder': 'No. pesanan, no. platform, atau pelanggan',
  'kasir.orders.allTypes': 'Semua jenis & platform',
  'kasir.orders.filter.kitchen': 'Status dapur',
  'kasir.orders.allKitchen': 'Semua status dapur',
  // ---- QRIS / kartu di terminal restoran (ADR-0050) --------------------------------
  'kasir.pay.method': 'Metode pembayaran',
  'kasir.pay.cash': 'Tunai',
  'kasir.pay.qris': 'QRIS',
  'kasir.pay.card': 'Kartu',
  'kasir.terminal.hintQris':
    'Pelanggan memindai QRIS restoran. Pastikan dana masuk di aplikasi merchant, lalu catat.',
  'kasir.terminal.hintCard':
    'Proses kartu di mesin EDC, lalu catat dengan kode approval dari struk EDC.',
  'kasir.terminal.amount': 'Jumlah',
  'kasir.terminal.amountHint': 'Isi lebih kecil dari sisa tagihan untuk bayar sebagian.',
  'kasir.terminal.reference': 'Kode approval / referensi',
  'kasir.terminal.referenceHint': 'Sesuai struk EDC atau QRIS (opsional).',
  'kasir.terminal.actionQris': 'Catat QRIS {amount}',
  'kasir.terminal.actionCard': 'Catat kartu {amount}',
  'kasir.terminal.tooMuch': 'Melebihi sisa tagihan — QRIS dan kartu tidak ada kembalian.',
  'kasir.bill.qrisLine': 'QRIS · {time}',
  'kasir.bill.cardLine': 'Kartu · {time}',
  'kasir.receipt.qrisLine': 'QRIS',
  'kasir.receipt.cardLine': 'Kartu',
  'kasir.receipt.refLine': 'Ref. {reference}',
  'kasir.receipt.qrisPaid': 'Dibayar dengan QRIS',
  'kasir.receipt.cardPaid': 'Dibayar dengan kartu',
  'kasir.pay.transfer': 'Transfer',
  'kasir.terminal.referenceHintTransfer': 'Nomor referensi transfer dari aplikasi bank (opsional).',
  'kasir.terminal.hintTransfer':
    'Pelanggan mentransfer ke rekening bank restoran. Pastikan dana sudah masuk di aplikasi bank Anda, lalu catat dengan nomor referensi transfer.',
  'kasir.terminal.actionTransfer': 'Catat transfer {amount}',
  'kasir.bill.transferLine': 'Transfer · {time}',
  'kasir.receipt.transferLine': 'Transfer bank',
  'kasir.receipt.transferPaid': 'Dibayar dengan transfer bank',
};
